import { useState } from "react";
import { Loader2, UserPlus } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const PLANS = [["", "No plan yet (14-day trial)"], ["basic-broadcaster", "Basic Broadcaster"], ["media-ministry-hub", "Media Ministry Hub"], ["premium-services", "Premium Services"], ["ascend-ultra", "Ascend Ultra"]];

export const ConvertDialog = ({ prospect, onClose, onDone }) => {
  const [email, setEmail] = useState(prospect.email || "");
  const [name, setName] = useState(prospect.pastor_name || "");
  const [password, setPassword] = useState("");
  const [plan, setPlan] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/crm/prospects/${prospect.id}/convert`, { email, name, password, plan });
      toast.success(`Customer account created for ${prospect.church_name}`, { description: `They can log in as ${email}` });
      onDone(r.data); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Couldn't create the account"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="convert-dialog" className="bg-[#0E131F] border-gray-800 text-white sm:max-w-[440px]">
        <DialogHeader>
          <DialogTitle className="font-display text-xl flex items-center gap-2"><UserPlus className="h-5 w-5 text-emerald-400" /> Create customer account</DialogTitle>
          <DialogDescription className="text-gray-400 text-sm">Creates a portal login for <span className="text-gray-200 font-medium">{prospect.church_name}</span> and marks the prospect as Customer.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 pt-1">
          <div className="space-y-1.5"><Label className="text-gray-400 text-xs">Login email</Label><Input data-testid="convert-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-black/30 border-gray-800" /></div>
          <div className="space-y-1.5"><Label className="text-gray-400 text-xs">Contact name</Label><Input data-testid="convert-name" value={name} onChange={(e) => setName(e.target.value)} className="bg-black/30 border-gray-800" /></div>
          <div className="space-y-1.5"><Label className="text-gray-400 text-xs">Temporary password</Label><Input data-testid="convert-password" type="text" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" className="bg-black/30 border-gray-800" /></div>
          <div className="space-y-1.5"><Label className="text-gray-400 text-xs">Plan</Label>
            <select data-testid="convert-plan" value={plan} onChange={(e) => setPlan(e.target.value)} className="w-full h-9 bg-black/30 border border-gray-800 rounded-md px-2 text-sm text-white">{PLANS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
          </div>
        </div>
        <div className="mt-4 flex justify-end gap-3">
          <button onClick={onClose} className="rounded-lg px-4 py-2 text-sm text-gray-400 hover:text-white">Cancel</button>
          <button data-testid="convert-submit" onClick={submit} disabled={busy || !email.includes("@") || !name.trim() || password.length < 6} className="inline-flex items-center gap-2 rounded-lg gold-gradient px-4 py-2 text-sm font-semibold text-black hover:brightness-110 disabled:opacity-50">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Create account
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
